import { createSlice } from '@reduxjs/toolkit'
export const mapRefreshSlice = createSlice({
  name: 'mapRefresh',
  initialState: {
    isRefreshMapData: false
  },
  reducers: {
    refreshMapData: (state, action) => {
      state.isRefreshMapData = action.payload;
      return state;
    },
  }
})
export const { refreshMapData } = mapRefreshSlice.actions;
export default mapRefreshSlice.reducer; 
